module.exports = __webpack_public_path__ + "img/applet-cel-box1.82370fdc.png";